import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20illustration%20with%20warm%20evening%20sunset%20lighting%2C%20minimalist%20composition%2C%20soft%20gradient%20sky%20in%20warm%20peach%20and%20coral%20tones%2C%20dreamy%20atmosphere%2C%20editorial%20quality%2C%20Korean%20webtoon%20aesthetic%20background%20with%20gentle%20clouds%20and%20scattered%20light%20particles%2C%20elegant%20and%20inviting%20mood&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
        alt="基德漫画网 - 好看韩漫漫画免费漫画在线观看"
        title="好看韩漫漫画免费漫画 - 韩漫免费漫画在线观看下拉式"
        className="w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            发现最精彩的
            <strong className="font-heading text-accent-400">韩漫</strong>
            世界
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-2xl mx-auto leading-relaxed">
            基德漫画网提供好看韩漫漫画免费漫画，支持韩漫免费漫画在线观看下拉式阅读体验。
            每日更新海量资源，让阅读更加便捷流畅。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              立即阅读
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </Link>
            <Link
              to="/category/fantasy"
              className="px-8 py-3 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">2000+</p>
              <p className="text-xs text-white/60 mt-1">漫画资源</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">50万+</p>
              <p className="text-xs text-white/60 mt-1">活跃读者</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">99.7%</p>
              <p className="text-xs text-white/60 mt-1">好评率</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}